import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Status_firme, ApiClientService } from '../../services/api-client.service';

@Component({
  selector: 'app-statusi-firme',
  templateUrl: './statusi-firme.component.html',
  styleUrls: ['./statusi-firme.component.scss']
})
export class StatusiFirmeComponent {
  @ViewChild('statusiGrid', { static: false }) statusiGrid: any;

  gridData: Status_firme[] = [];
  loading = false;
  isCreatePopupVisible = false;
  loadPanelPosition = { of: '#statusiGrid' };

  statusForm!: FormGroup;

  constructor(
    private apiClient: ApiClientService,
    private fb: FormBuilder
  ) {
    this.initializeForm();
  }

  ngOnInit() {
    this.loadStatusi();
  }

  initializeForm() {
    this.statusForm = this.fb.group({
      status: ['', Validators.required]
    });
  }

  async loadStatusi() {
    this.loading = true;
    try {
      this.gridData = await this.apiClient.statusiFirmeAll();
    } catch (error) {
      console.error('Error loading statusi:', error);
    } finally {
      this.loading = false;
    }
  }

  onAddClick() {
    this.statusForm.reset();
    this.isCreatePopupVisible = true;
  }

  async createStatus() {
    if (this.statusForm.valid) {
      this.loading = true;
      try {
        const formData = this.statusForm.value;
        await this.apiClient.statusiFirmePOST(formData);
        this.isCreatePopupVisible = false;
        this.statusForm.reset();
        this.loadStatusi(); // Refresh grid
      } catch (error) {
        console.error('Error creating status:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  onRefreshClick() {
    this.loadStatusi();
  }

  onCreatePopupHidden() {
    this.isCreatePopupVisible = false;
  }
}
